// extracted by css-extract-rspack-plugin
export default {"statusCell":"statusCell-_ykOov","statusTag":"statusTag-M8hvmE","statusText":"statusText-WrMG5R","labsWidget":"labsWidget-ThgRtI"};